<template>
  <div class="aad-page">
    <button class="aad-back" @click="router.push({ name: 'AdminAnnouncements' })">← 返回公告列表</button>

    <div v-if="loading" class="aad-state">載入中…</div>
    <div v-else-if="!ann" class="aad-state">找不到此公告</div>
    <div v-else class="aad-card">
      <div class="aad-meta">
        <span class="aad-badge" :class="ann.is_active ? 'aad-badge--on' : 'aad-badge--off'">
          {{ ann.is_active ? '顯示中' : '已停用' }}
        </span>
        <span class="aad-date">{{ fmtDate(ann.created_at) }}</span>
      </div>
      <h1 class="aad-title">{{ ann.title }}</h1>
      <p class="aad-content">{{ ann.content }}</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axios from 'axios'

const router = useRouter()
const route  = useRoute()
const ann     = ref(null)
const loading = ref(false)

function fmtDate(d) {
  return d ? new Date(d).toLocaleString('zh-TW', {
    timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit',
    day: '2-digit', hour: '2-digit', minute: '2-digit'
  }) : ''
}

onMounted(async () => {
  loading.value = true
  try {
    const { data } = await axios.get('/api/admin/booking/announcements')
    const id = Number(route.params.id)
    ann.value = (data.announcements || []).find(a => a.id === id) || null
  } catch (_) { /* 忽略 */ } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.aad-page { padding: 32px 24px 80px; max-width: 800px; }
.aad-back {
  background: none; border: none; cursor: pointer;
  font-size: 0.9rem; color: #8b6f5c; font-weight: 600;
  padding: 0; margin-bottom: 24px; display: inline-block;
  transition: opacity 0.15s;
}
.aad-back:hover { opacity: 0.7; }

.aad-state { color: #aaa; padding: 48px 0; text-align: center; }

.aad-card {
  background: #fff; border: 1px solid #e8e0da;
  border-radius: 12px; padding: 28px 28px 32px;
}
.aad-meta {
  display: flex; align-items: center; gap: 10px; margin-bottom: 14px;
}
.aad-badge {
  font-size: 0.72rem; font-weight: 600; padding: 2px 8px; border-radius: 20px;
}
.aad-badge--on  { background: #d4edda; color: #155724; }
.aad-badge--off { background: #f8d7da; color: #721c24; }
.aad-date { font-size: 0.8rem; color: #aaa; }

.aad-title {
  font-size: 1.4rem; font-weight: 700; color: #2c3e50;
  margin: 0 0 20px; line-height: 1.4;
}
.aad-content {
  font-size: 0.95rem; color: #444; white-space: pre-wrap;
  line-height: 1.9; margin: 0;
}
</style>
